/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramSupportContactsControllerCreateMutationRequest,
  TelegramSupportContactsControllerCreateMutationResponse,
  TelegramSupportContactsControllerCreate401,
} from '../../types/TelegramSupportContactsControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramSupportContactsCreate } from '../../methods/telegramSupportContactsCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramSupportContactsCreateMutationKey = () => [{ url: '/api/telegram/support-contacts' }] as const;

export type TelegramSupportContactsCreateMutationKey = ReturnType<typeof telegramSupportContactsCreateMutationKey>;

/**
 * {@link /api/telegram/support-contacts}
 */
export function useTelegramSupportContactsCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramSupportContactsControllerCreateMutationResponse,
      ResponseErrorConfig<TelegramSupportContactsControllerCreate401>,
      { data: TelegramSupportContactsControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramSupportContactsControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramSupportContactsCreateMutationKey();

  return useMutation<
    TelegramSupportContactsControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramSupportContactsControllerCreate401>,
    { data: TelegramSupportContactsControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramSupportContactsCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
